import {useContext} from 'react';
import {Box} from '@mui/material';
import {AppContext} from '../../contexts/app/context';
import {AppContextType} from '../../contexts/app/types';
import {ThemeMode} from '../../enums/theme-mode';
import {ReactComponent as LightLogo} from '../../logos/logo-stick-light.svg';
import {ReactComponent as DarkLogo} from '../../logos/logo-stick-dark.svg';
import {ReactComponent as PrimaryLogo} from '../../logos/logo-stick-primary.svg';
import {ProductLogo} from '../product-logo/product-logo';
import './product-logo-with-stick.scss';
import {AppVersionText} from '../app-version-text/app-version-text';

/**
 * Product logo component with the stick logo.
 */
export const ProductLogoWithStick = (props: {height: number; usePrimary?: boolean}) => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  // Hold logo stick component
  let Logo: any;

  // Evaluate current theme mode
  if (props.usePrimary && appContext.state.currentThemeMode !== ThemeMode.Dark) {
    // Use Primary
    Logo = PrimaryLogo;
  } else if (appContext.state.currentThemeMode === ThemeMode.Dark) {
    // Go Dark
    Logo = DarkLogo;
  } else {
    // Go Light
    Logo = LightLogo;
  }

  // Default result
  return (
    <Box className="product-logo-with-stick">
      <Logo
        height={props.height}
        width={appContext.state.currentThemeSettings.loginLogoStickWidth}
      />
      <ProductLogo height={appContext.state.currentThemeSettings.loginLogoHeight} />
      <AppVersionText
        sx={{
          position: 'absolute',
          bottom: -6,
          right: 0,
        }}
      />
    </Box>
  );
};
